unit uSubForm2;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.StdCtrls, WEBLib.Controls, WEBLib.Grids,
  WEBLib.DBCtrls, DB, WEBLib.CDS, WEBLib.DB, WEBLib.Buttons,
  WEBLib.TMSFNCTypes, WEBLib.TMSFNCUtils, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCImage, WEBLib.ExtCtrls, WEBLib.Imaging.pngimage, WEBLib.TMSFNCTrackBar,
  Variants, StrUtils, WEBLib.Imaging.jpeg;

type
  TSubForm2 = class(TForm)
    WebLabel1: TLabel;
    WebLabel4: TLabel;
    TMSFNCTrackBar1: TTMSFNCTrackBar;
    WebLabel6: TLabel;
    TMSFNCTrackBar2: TTMSFNCTrackBar;
    WebEdit3: TEdit;
    WebLabel7: TLabel;
    WebLabel5: TLabel;
    WebEdit2: TEdit;
    WebLabel2: TLabel;
    WebEdit1: TEdit;
    WebLabel3: TLabel;
    WebLabel8: TLabel;
    WebComboBox1: TComboBox;
    WebImageControl1: TImageControl;
    WebImageControl2: TImageControl;
    WebImageControl3: TImageControl;
    WebImageControl4: TImageControl;
    WebGroupBox1: TGroupBox;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebEdit4: TEdit;
    WebImageControl5: TImageControl;
    WebLabel15: TLabel;
    procedure WebBitBtn1Click(Sender: TObject);
    procedure WebDBGrid1Click(Sender: TObject);
    procedure TMSFNCTrackBar1ValueChanged(Sender: TObject; AValue: Single);
    procedure TMSFNCTrackBar2ValueChanged(Sender: TObject; AValue: Single);
    procedure WebFormCreate(Sender: TObject);
    procedure WebEdit1Change(Sender: TObject);
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebEdit2Change(Sender: TObject);
    procedure TMSFNCTrackBar1Changed(Sender: TObject);
  protected
    procedure LoadDFMValues; override;
  end;

var
  SubForm2: TSubForm2;

implementation


uses ufrmMain;

procedure TSubForm2.TMSFNCTrackBar1Changed(Sender: TObject);
var   KO, CE      : Real;
      OK          : Integer;
begin
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  if OK<>0 then
  if WebEdit2.Text<>'' then CE:=KO/StrtoFloat(WebEdit2.Text);
  WebEdit3.Text:=FloattoStr(CE);
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;

procedure TSubForm2.TMSFNCTrackBar1ValueChanged(Sender: TObject;
  AValue: Single);
var   KO, CE, NAD       : Real;
      OK                : Integer;
begin
  WebEdit2.Text:=FloattoStr(AValue*50);

  WebEdit1.Text:=FloattoStr(StrtoFloat(WebEdit2.Text)*StrtoFloat(WebEdit3.Text));
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  if StrtoFloat(WebEdit2.Text)>10000 then  NAD:=30 else NAD:=20;
  WebLabel14.Caption:=FloattoStr(StrtoFloat(WebLabel11.Caption)*(100+NAD)/100000);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;

procedure TSubForm2.TMSFNCTrackBar2ValueChanged(Sender: TObject;
  AValue: Single);
var   KO, CE, NAD       : Real;
      OK                : Integer;
begin
  WebEdit3.Text:=FloattoStr(AValue/100);

  WebEdit1.Text:=FloattoStr(StrtoFloat(WebEdit2.Text)*StrtoFloat(WebEdit3.Text));
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  if StrtoFloat(WebEdit2.Text)>10000 then  NAD:=30 else NAD:=20;
  WebLabel14.Caption:=FloattoStr(StrtoFloat(WebLabel11.Caption)*(100+NAD)/100000);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;

procedure TSubForm2.WebBitBtn1Click(Sender: TObject);
var    L    : String;
begin

end;

procedure TSubForm2.WebComboBox1Change(Sender: TObject);
var   KO, CE, NAD       : Real;
      OK                : Integer;
begin
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  if OK<>0 then
  if WebEdit2.Text<>'' then CE:=KO/StrtoFloat(WebEdit2.Text);
  WebEdit3.Text:=FloattoStr(CE);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  if StrtoFloat(WebEdit2.Text)>10000 then  NAD:=30 else NAD:=20;
  WebLabel14.Caption:=FloattoStr(StrtoFloat(WebLabel11.Caption)*(100+NAD)/100000);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;


procedure TSubForm2.WebDBGrid1Click(Sender: TObject);
var  im   : Integer;
      L   : String;
begin

end;

procedure TSubForm2.WebEdit1Change(Sender: TObject);
var   KO, CE, NAD       : Real;
      OK                : Integer;
begin
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  if OK<>0 then
  if WebEdit2.Text<>'' then CE:=KO/StrtoFloat(WebEdit2.Text);
  WebEdit3.Text:=FloattoStr(CE);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  if StrtoFloat(WebEdit2.Text)>10000 then  NAD:=30 else NAD:=20;  WebLabel14.Caption:=FloattoStr(StrtoFloat(WebLabel11.Caption)*(100+NAD)/100000);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;

procedure TSubForm2.WebEdit2Change(Sender: TObject);
var   KO, CE, NAD       : Real;
      OK                : Integer;
begin
  KO:=StrtoFloat(WebEdit1.Text);
  case WebComboBox1.ItemIndex of
  0: OK:=1;
  1: OK:=2;
  2: OK:=4;
  3: OK:=12;
  end;
  if OK<>0 then
  if WebEdit2.Text<>'' then CE:=KO/StrtoFloat(WebEdit2.Text);
  WebEdit3.Text:=FloattoStr(CE);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel11.Caption:=FloattoStr(StrtoFloat(WebEdit2.Text)*OK);
  WebEdit4.Text:=WebLabel11.Caption;
  WebLabel12.Caption:=FloattoStr(StrtoFloat(WebEdit1.Text)*OK);
  if StrtoFloat(WebEdit2.Text)>10000 then  NAD:=30 else NAD:=20;
  WebLabel14.Caption:=FloattoStr(StrtoFloat(WebLabel11.Caption)*(100+NAD)/100000);
  frmMain.WebEdit2.Text:=WebLabel11.Caption;
  frmMain.WebEdit3.Text:=WebLabel12.Caption;
  frmMain.WebEdit7.Text:=WebLabel14.Caption;
end;


procedure TSubForm2.WebFormCreate(Sender: TObject);
var
  bt, ed, lb, co: string;
begin
  //bootstrap class

  TMSFNCTrackBar1.Color:=clYellow;
  TMSFNCTrackBar1.Value:=20;
  TMSFNCTrackBar2.Value:=62;
  WebEdit1.Text:='620';
  FrmMain.WebEdit21.Text:=WebEdit3.Text;;
end;

procedure TSubForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebImageControl2 := TImageControl.Create(Self);
  WebImageControl3 := TImageControl.Create(Self);
  WebImageControl4 := TImageControl.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebImageControl5 := TImageControl.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  TMSFNCTrackBar1 := TTMSFNCTrackBar.Create(Self);
  TMSFNCTrackBar2 := TTMSFNCTrackBar.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebImageControl2.BeforeLoadDFMValues;
  WebImageControl3.BeforeLoadDFMValues;
  WebImageControl4.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebImageControl5.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  TMSFNCTrackBar1.BeforeLoadDFMValues;
  TMSFNCTrackBar2.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  try
    Name := 'SubForm2';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 6;
    WebImageControl1.Top := 110;
    WebImageControl1.Width := 94;
    WebImageControl1.Height := 71;
    WebImageControl1.ChildOrder := 14;
    WebImageControl1.Picture.LoadFromFile('uSubForm2.WebImageControl1.Picture.png');
    WebImageControl2.SetParentComponent(Self);
    WebImageControl2.Name := 'WebImageControl2';
    WebImageControl2.Left := 6;
    WebImageControl2.Top := 188;
    WebImageControl2.Width := 94;
    WebImageControl2.Height := 70;
    WebImageControl2.ChildOrder := 15;
    WebImageControl2.Picture.LoadFromFile('uSubForm2.WebImageControl2.Picture.png');
    WebImageControl3.SetParentComponent(Self);
    WebImageControl3.Name := 'WebImageControl3';
    WebImageControl3.Left := 6;
    WebImageControl3.Top := 264;
    WebImageControl3.Width := 94;
    WebImageControl3.Height := 71;
    WebImageControl3.ChildOrder := 16;
    WebImageControl3.Picture.LoadFromFile('uSubForm2.WebImageControl3.Picture.png');
    WebImageControl4.SetParentComponent(Self);
    WebImageControl4.Name := 'WebImageControl4';
    WebImageControl4.Left := 6;
    WebImageControl4.Top := 341;
    WebImageControl4.Width := 94;
    WebImageControl4.Height := 77;
    WebImageControl4.ChildOrder := 17;
    WebImageControl4.Picture.LoadFromFile('uSubForm2.WebImageControl4.Picture.png');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 6;
    WebLabel1.Top := 85;
    WebLabel1.Width := 96;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Zu'#380'ycie energii';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlue;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 106;
    WebLabel2.Top := 379;
    WebLabel2.Width := 208;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Warto'#347#263' rachunk'#243'w za energi'#281' /dla okresu/';
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 164;
    WebLabel3.Top := 402;
    WebLabel3.Width := 18;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'PLN';
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 106;
    WebLabel4.Top := 137;
    WebLabel4.Width := 135;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Zapotrzebowanie dla okresu';
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 294;
    WebLabel5.Top := 134;
    WebLabel5.Width := 21;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'kWh';
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 106;
    WebLabel6.Top := 209;
    WebLabel6.Width := 121;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Cena energii elektrycznej';
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 277;
    WebLabel7.Top := 209;
    WebLabel7.Width := 43;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'PLN/kWh';
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 106;
    WebLabel8.Top := 294;
    WebLabel8.Width := 94;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Okres rozliczeniowy';
    WebImageControl5.SetParentComponent(Self);
    WebImageControl5.Name := 'WebImageControl5';
    WebImageControl5.Left := 345;
    WebImageControl5.Top := 85;
    WebImageControl5.Width := 280;
    WebImageControl5.Height := 219;
    WebImageControl5.ChildOrder := 20;
    WebImageControl5.Picture.LoadFromFile('uSubForm2.WebImageControl5.Picture.jpg');
    WebLabel15.SetParentComponent(Self);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 8;
    WebLabel15.Top := 427;
    WebLabel15.Width := 211;
    WebLabel15.Height := 13;
    WebLabel15.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel15.Color := clYellow;
    WebLabel15.Transparent := False;
    TMSFNCTrackBar1.SetParentComponent(Self);
    TMSFNCTrackBar1.Name := 'TMSFNCTrackBar1';
    TMSFNCTrackBar1.Left := 106;
    TMSFNCTrackBar1.Top := 155;
    TMSFNCTrackBar1.Width := 214;
    TMSFNCTrackBar1.Height := 26;
    TMSFNCTrackBar1.ParentDoubleBuffered := False;
    TMSFNCTrackBar1.Color := clYellow;
    TMSFNCTrackBar1.DoubleBuffered := True;
    TMSFNCTrackBar1.TabOrder := 0;
    TMSFNCTrackBar1.Appearance.ButtonStroke.Color := clGray;
    TMSFNCTrackBar1.Appearance.ButtonDownStroke.Color := clGray;
    TMSFNCTrackBar1.Appearance.ThumbStroke.Color := clGray;
    TMSFNCTrackBar1.Appearance.ThumbDownStroke.Color := clGray;
    TMSFNCTrackBar1.Appearance.LineStroke.Color := clGray;
    TMSFNCTrackBar1.Appearance.TickMarkStroke.Color := clGray;
    TMSFNCTrackBar1.Fill.Kind := gfkNone;
    TMSFNCTrackBar1.Stroke.Kind := gskNone;
    TMSFNCTrackBar1.Max := 500.000000000000000000;
    SetEvent(TMSFNCTrackBar1, Self, 'OnChanged', 'TMSFNCTrackBar1Changed');
    SetEvent(TMSFNCTrackBar1, Self, 'OnValueChanged', 'TMSFNCTrackBar1ValueChanged');
    TMSFNCTrackBar2.SetParentComponent(Self);
    TMSFNCTrackBar2.Name := 'TMSFNCTrackBar2';
    TMSFNCTrackBar2.Left := 106;
    TMSFNCTrackBar2.Top := 232;
    TMSFNCTrackBar2.Width := 214;
    TMSFNCTrackBar2.Height := 25;
    TMSFNCTrackBar2.ParentDoubleBuffered := False;
    TMSFNCTrackBar2.Color := clBtnFace;
    TMSFNCTrackBar2.DoubleBuffered := True;
    TMSFNCTrackBar2.TabOrder := 1;
    TMSFNCTrackBar2.Appearance.ButtonStroke.Color := clGray;
    TMSFNCTrackBar2.Appearance.ButtonDownStroke.Color := clGray;
    TMSFNCTrackBar2.Appearance.ThumbStroke.Color := clGray;
    TMSFNCTrackBar2.Appearance.ThumbDownStroke.Color := clGray;
    TMSFNCTrackBar2.Appearance.LineStroke.Color := clGray;
    TMSFNCTrackBar2.Appearance.TickMarkStroke.Color := clGray;
    TMSFNCTrackBar2.Fill.Kind := gfkNone;
    TMSFNCTrackBar2.Stroke.Kind := gskNone;
    TMSFNCTrackBar2.Max := 100.000000000000000000;
    SetEvent(TMSFNCTrackBar2, Self, 'OnValueChanged', 'TMSFNCTrackBar2ValueChanged');
    WebComboBox1.SetParentComponent(Self);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 106;
    WebComboBox1.Top := 313;
    WebComboBox1.Width := 94;
    WebComboBox1.Height := 22;
    WebComboBox1.Color := clInfoBk;
    WebComboBox1.Text := 'Roczny';
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('Roczny');
      WebComboBox1.Items.Add('P'#243#322'roczny');
      WebComboBox1.Items.Add('Kwartalny');
      WebComboBox1.Items.Add('Miesi'#281'czny');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit1.SetParentComponent(Self);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 106;
    WebEdit1.Top := 399;
    WebEdit1.Width := 49;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 10;
    WebEdit1.Color := clInfoBk;
    WebEdit1.Text := '0';
    SetEvent(WebEdit1, Self, 'OnChange', 'WebEdit1Change');
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 250;
    WebEdit2.Top := 131;
    WebEdit2.Width := 38;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 8;
    WebEdit2.Color := clInfoBk;
    WebEdit2.Text := '1000';
    SetEvent(WebEdit2, Self, 'OnChange', 'WebEdit2Change');
    WebEdit3.SetParentComponent(Self);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 233;
    WebEdit3.Top := 206;
    WebEdit3.Width := 38;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 9;
    WebEdit3.Color := 16777200;
    WebEdit3.Text := '0,6';
    WebEdit4.SetParentComponent(Self);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 472;
    WebEdit4.Top := 269;
    WebEdit4.Width := 121;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 19;
    WebEdit4.Visible := False;
    WebGroupBox1.SetParentComponent(Self);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 345;
    WebGroupBox1.Top := 310;
    WebGroupBox1.Width := 280;
    WebGroupBox1.Height := 131;
    WebGroupBox1.Caption := 'Dane wynikowe ';
    WebGroupBox1.ChildOrder := 18;
    WebLabel9.SetParentComponent(WebGroupBox1);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 8;
    WebLabel9.Top := 26;
    WebLabel9.Width := 148;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'Zu'#380'ycie roczne energii [kWh] : ';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clBlue;
    WebLabel9.Font.Height := -11;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.ParentFont := False;
    WebLabel10.SetParentComponent(WebGroupBox1);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 8;
    WebLabel10.Top := 57;
    WebLabel10.Width := 138;
    WebLabel10.Height := 13;
    WebLabel10.Caption := 'Koszty roczne energii [PLN] :';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clBlue;
    WebLabel10.Font.Height := -11;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.ParentFont := False;
    WebLabel11.SetParentComponent(WebGroupBox1);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 163;
    WebLabel11.Top := 26;
    WebLabel11.Width := 4;
    WebLabel11.Height := 13;
    WebLabel11.Caption := '-';
    WebLabel12.SetParentComponent(WebGroupBox1);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 163;
    WebLabel12.Top := 58;
    WebLabel12.Width := 4;
    WebLabel12.Height := 13;
    WebLabel12.Caption := '-';
    WebLabel13.SetParentComponent(WebGroupBox1);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 8;
    WebLabel13.Top := 105;
    WebLabel13.Width := 203;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Sugerowana wielko'#347#263' instalacji PV [kWp] : ';
    WebLabel14.SetParentComponent(WebGroupBox1);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 215;
    WebLabel14.Top := 105;
    WebLabel14.Width := 4;
    WebLabel14.Height := 13;
    WebLabel14.Caption := '-';
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebImageControl2.AfterLoadDFMValues;
    WebImageControl3.AfterLoadDFMValues;
    WebImageControl4.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebImageControl5.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    TMSFNCTrackBar1.AfterLoadDFMValues;
    TMSFNCTrackBar2.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
  end;
end;

end.
